import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

type PostQualityEventsArgs = {
    events: Record<string, unknown>[];
};

type PostQualityEventsResponse = {
    track_sid?: string;
};

export const postQualityEvents = (data: PostQualityEventsArgs) =>
    // TODO: project-wide axios typing — see header-school-menu.ts
    axios.post(API_URLS.QUALITY_EVENTS, data) as unknown as Promise<PostQualityEventsResponse>;
